import React from "react";

const Profile = props => {
  return <h1>Welcome to profile!</h1>;
};

export default Profile;
